import { render, staticRenderFns } from "./InvoicingTab.vue?vue&type=template&id=13d23e12&scoped=true"
import script from "./InvoicingTab.vue?vue&type=script&lang=js"
export * from "./InvoicingTab.vue?vue&type=script&lang=js"
import style0 from "./InvoicingTab.vue?vue&type=style&index=0&id=13d23e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d23e12",
  null
  
)

export default component.exports